import React from 'react'
import { CurrentNavHeader } from '../../components/current-nav-header/CurrentNavHeader'
import { RouteProps } from '../../routes/AppRouter'
import { AssignTo as TF } from '../../features/form-generator/AssignTo'
import { ROUTE_CREATE } from '../../routes/routes-constants'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function FormGeneratorAssignTo(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return (
    <>
      <TF id={props.id === ROUTE_CREATE ? undefined : props.id} />
    </>
  )
}
